export default __webpack_public_path__ + "static/media/help-rav-qa-7.4b38a523.png";